import { DataListHeader, Panel } from 'mailup-web-components'
import { pageState } from 'Pages/TasksList/recoil/state/page'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'
import Pagination from './Pagination'
import Row from './Row'
import RowsPlaceholder from './RowsPlaceholder'

const Results = ({ items }) => {
  const intl = useIntl()

  const { fetchingResults } = useRecoilValue(pageState)

  const heads = [
    {
      field: 'Name',
      label: intl.formatMessage({
        id: 'Load.TriggersList.Tasks'
      }),
      span: 6
    },
    {
      field: 'NextRealRunDate',
      label: intl.formatMessage({
        id: 'Load.TriggersList.NexDate'
      }),
      span: 3
    },
    {
      field: 'Frequency',
      label: intl.formatMessage({
        id: 'Load.TriggersList.Frequency'
      }),
      span: 2
    },
    {
      field: 'Enabled',
      label: intl.formatMessage({
        id: 'Load.TriggersList.Status'
      }),
      span: 1
    }
  ]
  const COLUMN_BEFORE_WIDTH = '15px'
  const COLUMN_AFTER_WIDTH = '80px'

  return (
    <>
      {items && (
        <Panel>
          <DataListHeader
            heads={heads}
            beforeWidth={COLUMN_BEFORE_WIDTH}
            afterWidth={COLUMN_AFTER_WIDTH}
          />
          <div>
            {fetchingResults ? (
              <RowsPlaceholder
                heads={heads}
                beforeWidth={COLUMN_BEFORE_WIDTH}
                afterWidth={COLUMN_AFTER_WIDTH}
              />
            ) : (
              items.map((item, key) => {
                return <Row key={key} item={item} heads={heads} />
              })
            )}
          </div>
          <Pagination />
        </Panel>
      )}
    </>
  )
}

export default Results

Results.propTypes = {
  items: PropTypes.array
}
